module.exports = __webpack_public_path__ + "static/img/rank_95.2243313.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_95.png
// module id = osgF
// module chunks = 0